import { del, get, patch, post, put } from "./api_helper";
import * as url from "./url_helper";

/* Positions */
export const postPositions = data => post(url.POSITION, data);
export const deletePositions = id => del(url.POSITION + id + '/');
export const getPositions = params => get(url.POSITION, { params });
export const getPositionsByPosId = id => get(url.POSITION + id + "/");
export const patchPositions = (id, data) => patch(url.POSITION + id + "/", data);

/* Groups */
export const getGroups = () => get(url.GROUPS);

// get campaigns List
export const getCampaignsList = params =>
  get(url.GET_CAMPAIGNS_LIST, { params });

// get campaigns List
export const getWarehouseIntegrationCampaignsVkList = params =>
  get(url.API_WAREHOUSE_INTEGRATION_VK_CAMPAIGN, { params });

// get banners List
export const getWarehouseIntegrationBannersVkList = params =>
  get(url.API_WAREHOUSE_INTEGRATION_VK_BANNER, { params })

// get advertisers List
export const getWarehouseIntegrationAdvertisersTikTokList = params =>
  get(url.API_WAREHOUSE_INTEGRATION_TIKTOK_ADVERTISERS, { params })

// get agencies List
export const getWarehouseIntegrationAgenciesMTList = params =>
  get(url.API_WAREHOUSE_INTEGRATION_MT_AGENCIES, { params });

// get banners List
export const getWarehouseIntegrationBannersMTList = params =>
  get(url.API_WAREHOUSE_INTEGRATION_MT_BANNERS, { params });

// get campaigns List
export const getWarehouseIntegrationCampaignsMTList = params =>
  get(url.API_WAREHOUSE_INTEGRATION_MT_CAMPAIGNS, { params });

//get offers data client data.page data.sizePerPage data.ordering`
export const getOffersList = (params) => get(url.OFFERS_API, { params });
export const getOffersByContractorId = (params) => get(url.PLAN_API + 'offers_with_stat/', { params });
export const getOffersByBuyersList = (params) => get(url.OFFERS_API + 'filter_by_buyers/', { params });

// export const getOffersForClient = (page, size, id) => get(url.OFFERS_API + `?app__client=${id}&page=${page}&size=${size}`);
export const getOffersForClient = (params, ordering) => get(url.OFFERS_API + `${ordering && `?ordering=${ordering}`}`, { params });

export const getOffersForClientByClientId = id => get(url.OFFERS_API + `?app__client=${id}`);

// get offer data
export const getOfferData = params =>
  get(url.GET_OFFER_DATA, { params });

export const getOfferById = (id, params) =>
  get(url.OFFERS_API + id + "/", {params});

export const patchOfferById = ({ id, data }) =>
  patch(url.OFFERS_API + id + "/", data);

export const patchOfferStatus = params =>
  patch(url.OFFERS_STATUS_API + `?offer_ids=${params.offer_ids}&status=${params.status}`);

//delete offer
export const deleteOfferById = (id, need_delete_all_offer = false) =>
  del(url.OFFERS_API + id + '/', {data: {need_delete_all_offer}})

// get offer history
export const getHistory = id => get(url.OFFERS_API + id + "/history/")
export const deleteOfferHistory = id => del(url.OFFERS_API + id + "/")

// get events
export const getEvents = params =>
  get(url.EVENTS_API, { params })

// get invoices
export const getInvoices = params =>
  get(url.INVOICES_API, { params })

  export const postInvoice = data =>
  post(url.INVOICES_API, data)

export const postCustomInvoice = data =>
  post(url.INVOICES_API + 'custom/', data)

export const getInvoice = id =>
  get(url.INVOICES_API + id + "/")

export const getInvoiceItems = params =>
  get(url.INVOICES_ITEMS_API, { params })

export const patchInvoice = (id, data) =>
  patch(url.INVOICES_API + id + "/", data)

export const getInvoicesFilters = () =>
  get(url.INVOICES_API + 'filter_data' + "/")

export const deleteInvoice = id =>
  del(url.INVOICES_API + id + "/")

export const getInvoiceChoice = () => get(url.INVOICES_API + 'choices/');

export const postInvoiceOffer = params => post(url.INVOICES_API + 'offer/', params);

export const postInvoiceSalary = params => post(url.INVOICES_API + 'salary/', params);

export const getAggregatedInvoiceStaffData = (params) => get(url.INVOICES_API + 'salary_report/', { params });

// Invoices Templates

export const getInvoiceTemplates = (params) => get(url.INVOICES_TEMPLATES_API, { params });

export const postInvoiceTemplates = (params) => post(url.INVOICES_TEMPLATES_API, params);

export const delInvoiceTemplates = (id) => del(url.INVOICES_TEMPLATES_API + id + '/');

export const patchInvoiceTemplates = (id, params) => patch(url.INVOICES_TEMPLATES_API + id + '/', params)

// Plans

export const getTotalProfitPlanData = (params) => get(url.PLAN_TOTAL_PROFIT, { params })
export const getTotalPlanData = (params) => get(url.PLAN_TOTAL_PLAN, { params });

export const getCustomProfitByDayBulk = (params) => get(url.PLAN_CUSTOM_BY_DAY_BULK, { params })
export const postCustomProfitByDayBulk = (params) => post(url.PLAN_CUSTOM_BY_DAY_BULK, params)
export const patchCustomProfitByDayBulk = (params) => patch(url.PLAN_CUSTOM_BY_DAY_BULK, params)
export const deleteCustomProfitByDayBulk = (ids) => del(url.PLAN_CUSTOM_BY_DAY_BULK + `?ids=${ids}`)

export const postManagerCashbackBulk = params => post(url.PLAN_CASHBACK_BULK, params);
export const patchManagerCashbackBulk = params => patch(url.PLAN_CASHBACK_BULK, params);
export const deleteManagerCashbackBulk = ids => del(url.PLAN_CASHBACK_BULK  + `?ids=${ids}`);

export const getProfitByDays = (params) => get(url.PLAN_API + 'profit_by_day/', { params })
export const getCostByDays = (params) => get(url.PLAN_API + 'cost_by_day/', { params })
export const getMarginByDays = (params) => get(url.PLAN_API + 'margin_by_day/', { params })

export const getPlansProfitWidgets = (params) => get(url.PLAN_PROFIT_WIDGET, { params });

export const getProfitPlanOfferData = (params) => get(url.PLAN_API + 'profit_offers/', { params });

export const getProfitPlanMarginData = (params) => get(url.PLAN_API + 'margin/', { params });

export const getProfitPlanExecutionData = (params) => get(url.PLAN_API + 'execution/', { params });
export const getProfitExecFiltersData = () => get(url.PLAN_API + 'plan_execution_filter/');
export const getProfitMarginFiltersData = () => get(url.PLAN_API + 'margin_filter/');

export const getAggregatedManagersProfitData = (params) => get(url.PLAN_API + 'aggregated_managers_profit/', { params });
export const getAggregatedOfferProfitData = (params) => get(url.PLAN_API + 'aggregated_offer_profit/', { params });
export const getPlansHROfferDetailed = (params) => get(url.PLAN_API + 'hr_offer_detailed/', { params });

// export const patchCustomProfitByDay_bulk = (id, params) =>
//   patch()
  
export const getPlanFilterData = () =>
  get(url.PLAN_API + 'filter_data/')

export const getPlans = (params, query = "") =>
  get(url.PLAN_API + `?${query}`, { params })

export const getPlansBulk = (params, query = "") =>
  get(url.PLAN_BULK_API, { params })

export const getPlanProfitData = (params) =>
  get(url.PLAN_API + 'profit/', { params });

export const getPlan = id =>
  get(url.PLAN_API + id + "/")

export const postPlan = data =>
  post(url.PLAN_API, data)

export const postPlanBulk = data =>
  post(url.PLAN_BULK_API, data)

export const deletePlanBulk = params =>
  del(url.PLAN_BULK_API,  { params })

export const postPlansGroups = params =>
  post(url.PLAN_GROUPS_BULK, params)

export const getPlansGroups = (params) =>
  get(url.PLAN_GROUPS, {params})

export const postPlansGroup = (params) =>
  post(url.PLAN_GROUPS, params)

export const deletePlansGroups = (params) =>
  del(url.PLAN_GROUPS_BULK, {params})

export const updatePlansGroup = (id, params) =>
  patch(url.PLAN_GROUPS + id + "/", params)

export const patchPlansBulk = (data) =>
  patch(url.PLAN_BULK_API, data)

export const patchPlan = (id, data) =>
  patch(url.PLAN_API + id + "/", data)

export const deletePlan = id =>
  del(url.PLAN_API + id + "/")

export const getCustomProfit = data =>
  post(url.PLAN_CUSTOM_PROFIT, {data})

export const postCustomProfit = data =>
  post(url.PLAN_CUSTOM_PROFIT, data)

export const postCustomProfitCashback = data =>
  post(url.PLAN_CASHBACK, data);

export const patchCustomProfitCashback = (id, data) =>
  patch(url.PLAN_CASHBACK + `${id}/`, data);

export const deleteCustomProfit = id =>
  del(url.PLAN_CUSTOM_PROFIT + id + '/')

export const patchCustomProfit = (id, data) =>
  patch(url.PLAN_CUSTOM_PROFIT + id + '/', data)

// get trackers
export const getTrackers = params =>
  get(url.TRACKERS_API, { params });
// post trackers
export const postTrackers = data =>
  post(url.TRACKERS_API, data);
// delete trackers
export const deleteTrackers = id =>
  del(url.TRACKERS_API + id + "/");
// get offer tracker profile
export const getTrackerOfferProfile = id =>
  get(url.TRACKERS_API + id + "/");
// put offer tracker profile
export const putTrackerOfferProfile = (id, data) =>
  put(url.TRACKERS_API + id + "/", data);

export const getOffersWithRegularMatching = (params) => get(url.OFFERS_WITH_REGULAR_MARCHING, { params })

// post offer
export const postOffer = data => post(url.OFFERS_API, data);

// filtered media buyers budget
export const getFilteredMediaBuyerBudgets = (filter, params) =>
  get(url.GET_MEDIA_BUYER_BUDGETS + `?${filter}`, { params });

// get media buyers budget
export const getMediaBuyerBudgets = params =>
  get(url.GET_MEDIA_BUYER_BUDGETS, { params });

// delete media buyers budget
export const deleteMediaBuyerBudgets = id =>
  del(url.GET_MEDIA_BUYER_BUDGETS + id + "/");
// post media buyers budget
export const postMediaBuyerBudget = data =>
  post(url.GET_MEDIA_BUYER_BUDGETS, data);

export const getMediaBuyerBudgetByBudgetId = id =>
  get(url.GET_MEDIA_BUYER_BUDGETS + id + "/");

export const patchMediaBuyerBudget = (id, data) =>
  patch(url.GET_MEDIA_BUYER_BUDGETS + id + "/", data);

// plans/offers
export const getPlansOffers = params =>
  get(url.PLANS_OFFERS, { params });

export const getPlansOffersById = id =>
  get(url.PLANS_OFFERS + id + '/');

// plans/media_buyers
export const getPlansMediaBuyers = params =>
  get(url.PLANS_MEDIA_BUYERS, { params });

export const postPlansMediaBuyersVoucher = params =>
  post('/media-buyer/vouchers/bulk', params);

export const patchPlansMediaBuyersVoucher = (params) =>
  patch(`/media-buyer/vouchers/bulk`, params);

export const delPlansMediaBuyersVoucher = (ids) =>
  del(`/media-buyer/vouchers/bulk?ids=${ids}`);

// filtered media buyers plans
export const getFilteredMediaBuyerPlans = (filter, params) =>
  get(url.PLANS_OFFERS + `?${filter}`, { params });

export const getMediaBuyerPlansParams = (params) =>
  get(url.PLANS_OFFERS + `params/`, { params });

export const postMediaBuyerPlan = data => post(url.PLANS_OFFERS, data);

export const deleteMediaBuyerPlans = id =>
  del(url.PLANS_OFFERS + id + "/");

export const patchPlanOffer = (id, data) =>
  patch(url.PLANS_OFFERS + id + "/", data);

export const patchPlanMediaBuyer = (id, data) =>
  patch(url.PLANS_MEDIA_BUYERS + id + "/", data);

export const getMediaBuyerPlanByBudgetId = id =>
  get(url.PLANS_OFFERS + id + "/");

export const getMediaBuyerPlanProfit = params =>
  get(url.PLANS_MEDIA_BUYERS_PROFIT + '/', { params })

// meta countries
export const getMetaCountries = params => get(url.GET_META_COUNTRIES, { params });

// notifications
export const getNotify = () => get(url.NOTIFICATIONS);
export const patchNotify = (formData, id) => patch(url.NOTIFICATIONS + `${id}/`, formData, {
  headers: {
    "accept": "application/json",
    "Content-Type": "multipart/form-data; boundary=----WebKitFormBoundary3vMCbUC48UL7bRn0"
  }
});
export const putViewAllNotify = () => put(url.NOTIFICATIONS + `view_all/`);
export const deleteNotify = (id) => del(url.NOTIFICATIONS + `${id}/`);

// user actions
export const getUsersActions = params => get(url.GET_USERS_ACTIONS, { params });
export const getUsersActionsFiltersQuery = () => get(url.GET_USERS_ACTIONS + `action_filter_options/`, {});

// user payout conditions 

export const getUserPayoutConditionApi = params => get(url.USER_PAYOUT_CONDITIONS, { params });
export const addUserPayoutConditionApi = params => post(url.USER_PAYOUT_CONDITIONS, params);
export const patchUserPayoutConditionApi = (id, params) => patch(url.USER_PAYOUT_CONDITIONS + `${id}/`, params);
export const deleteUserPayoutConditionApi = id => del(url.USER_PAYOUT_CONDITIONS + `${id}/`);

// user salary conditions
export const getUserSalaryConditionApi = params => get(url.USER_SALARY_CONDITIONS, { params });
export const addUserSalaryConditionApi = params => post(url.USER_SALARY_CONDITIONS, params);
export const patchUserSalaryConditionApi = (id, params) => patch(url.USER_SALARY_CONDITIONS + `${id}/`, params);
export const deleteUserSalaryConditionApi = id => del(url.USER_SALARY_CONDITIONS + `${id}/`);

// users get
export const getUsersList = params => get(url.GET_USERS, { params });
// users delete
export const deleteUsers = id => del(url.GET_USERS + id + "/");
// users post
export const addUser = data => post(url.GET_USERS, data);
// user get profile
export const getUserProfile = id => get(url.GET_USERS + id + "/");
// user patch profile
export const patchUserProfile = (id, params) => patch(url.GET_USERS + id + "/", params);
// user get settings
export const getUserSettings = (params = {}) => get(url.GET_USERS + "user_settings/", params);
// user patch settings
export const patchUserSettings = (params = {}) => patch(url.GET_USERS + "user_settings/", params);

// get clients list
export const getClientsList = params => get(url.API_CLIENTS, { params });

// delete client
export const deleteClient = id => del(url.API_CLIENTS + id + "/");

// get client
export const getClient = id => get(url.API_CLIENTS + id + "/");

// post client
export const postClient = (data) =>
  post(url.API_CLIENTS, data);

// post clients docs
export const postClientDocuments = formData =>
  post(url.API_CLIENT_DOCUMENTS, formData, {
    headers: {
      "accept": "*/*",
      // "Access-Control-Allow-Origin": "*",
      "Content-Type": "multipart/form-data;",
      // "Content-Length": 58
    }
  });

export const pathClientDocument = (id, formData) =>
  patch(url.API_CLIENT_DOCUMENTS + id + '/', formData, {
    headers: {
      "accept": "application/json",
      // "Access-Control-Allow-Origin": "*",
      // "Content-Type": "multipart/form-data;",
      "Content-Type": "multipart/form-data; boundary=----WebKitFormBoundary3vMCbUC48UL7bRn0"
      // "Content-Length": 58
    }
  })

// patch client
export const patchClient = (id, data) =>
  patch(url.API_CLIENTS + id + "/", data);

// get warehouse integration clients vk list
export const getWarehouseIntegrationClientsVkList = params => get(url.API_WAREHOUSE_INTEGRATION_VK_CLIENTS, { params });

// get legal entity
export const getLegalEntity = params => get(url.API_LEGAL_ENTITY, { params });
export const getLegalEntityNames = () => get(url.API_LEGAL_ENTITY + 'names/')
// post legal entity
export const postLegalEntity = data => post(url.API_LEGAL_ENTITY, data, {
  headers: {
    "accept": "application/json",
    "Content-Type": "multipart/form-data; boundary=----WebKitFormBoundary3vMCbUC48UL7bRn0"
  }
});
// delete legal entity
export const deleteLegalEntity = id => del(url.API_LEGAL_ENTITY + id + "/");
// get legal entity profile
export const getLegalEntityProfile = id => get(url.API_LEGAL_ENTITY + id + "/");
// patch legal entity profile
export const patchLegalEntityProfile = (id, data) => patch(url.API_LEGAL_ENTITY + id + "/", data);
// delete signature profile
export const deleteLegalEntitySignature = (id) => del(url.API_LEGAL_ENTITY + id + "/delete_signature/");

// get cohort report
export const getCohortReport = (params, api, etc = {}) => get(url.API_COHORT_REPORT + api, { params, ...etc });
// get cohort report templates
export const getCohortReportTemplates = params => get(url.API_COHORT_REPORT_TEMPLATES, params)
export const postCohortReportTemplates = data => post(url.API_COHORT_REPORT_TEMPLATES, data)
export const deleteCohortReportTemplates = id => del(url.API_COHORT_REPORT_TEMPLATES + id + '/')
export const patchCohortReportTemplates = (id, params) => patch(url.API_COHORT_REPORT_TEMPLATES + id + '/', params)

export const getCohortReportNames = () => get(url.API_COHORT_REPORT + 'names/')
// post cohort report
export const postCohortReport = data => post(url.API_COHORT_REPORT, data);
// delete cohort report
export const deleteCohortReport = id => del(url.API_COHORT_REPORT + id + "/");
// get cohort report profile
export const getCohortReportProfile = id => get(url.API_COHORT_REPORT + id + "/");
// patch cohort report profile
export const patchCohortReportProfile = (id, data) => patch(url.API_COHORT_REPORT + id + "/", data);
// get cohort report options
export const getCohortReportOptions = params => get(url.API_COHORT_REPORT_OPTIONS, { params });
export const getCohortReportParamsForFragmentation = params => get(url.API_COHORT_REPORT_PARAMS_FOR_FRAGMENTATION, { params });
export const getCohortReportFilterData = params => get(url.API_COHORT_REPORT_FILTER_DATA, { params })

// get contracts
export const getContracts = params => get(url.API_CONTRACTS, { params });
// post contracts
export const postContracts = data => post(url.API_CONTRACTS, data);
// delete contracts
export const deleteContracts = id => del(url.API_CONTRACTS + id + "/");
// get contracts profile
export const getContractsProfile = id => get(url.API_CONTRACTS + id + "/");
// patch contracts profile
export const patchContractsProfile = (id, data) => patch(url.API_CONTRACTS + id + "/", data);

// service providers
export const getServiceProvidersApi = params => get(url.API_SERVICE_PROVIDERS, { params });
export const postServiceProviderApi = data => post(url.API_SERVICE_PROVIDERS, data);
export const deleteServiceProviderApi = id => del(url.API_SERVICE_PROVIDERS + id + "/");
export const getServiceProviderProfileApi = id => get(url.API_SERVICE_PROVIDERS + id + "/");
export const patchServiceProviderProfile = (id, data) => patch(url.API_SERVICE_PROVIDERS + id + "/", data);
export const getServiceProviderWidgets = (params) => get(url.API_SERVICE_PROVIDERS + 'stats/', { params });

// get payment formulas
export const getPaymentFormula = params =>
  get(url.PAYMENT_FORMULAS, { params });

// post payment formulas
export const postPaymentFormula = data =>
  post(url.PAYMENT_FORMULAS, data);

// post payment formulas
export const deletePaymentFormula = id =>
  del(url.PAYMENT_FORMULAS + id + "/");

// get payment formula profile
export const getPaymentFormulaProfile = id => get(url.PAYMENT_FORMULAS + id + "/");

// get payment formula profile
export const patchPaymentFormulaProfile = (id, params) => patch(url.PAYMENT_FORMULAS + id + "/", params);

// get payment absolute params
export const getPaymentParams = data =>
  get(url.META_VARIABLES, data);

// get campaign
export const getCampaign = id => get(url.GET_CAMPAIGNS_LIST + id + "/");

// put campaign
export const putCampaign = (id, data) => put(url.GET_CAMPAIGNS_LIST + id + "/", data);

// get campaign formats
export const getCampaignFormatsList = params =>
  get(url.GET_CAMPAIGN_FORMAT_LIST, { params });
// post campaign formats
export const postCampaignFormat = data =>
  post(url.GET_CAMPAIGN_FORMAT_LIST, data);
// get campaign format profile
export const getCampaignFormatProfile = id =>
  get(url.GET_CAMPAIGN_FORMAT_LIST + id + "/");
// put campaign format profile
export const putCampaignFormatProfile = (id, data) =>
  put(url.GET_CAMPAIGN_FORMAT_LIST + id + "/", data);
// delete campaign formats
export const deleteCampaignFormat = id =>
  del(url.GET_CAMPAIGN_FORMAT_LIST + id + "/");

// get campaign status
export const getCampaignStatuses = params => get(url.GET_CAMPAIGN_STATUSES, { params });
// post campaign status
export const postCampaignStatus = data => post(url.GET_CAMPAIGN_STATUSES, data);
// delete campaign status
export const deleteCampaignStatus = id => del(url.GET_CAMPAIGN_STATUSES + id + "/");
// get campaign status profile
export const getCampaignStatusProfile = id => get(url.GET_CAMPAIGN_STATUSES + id + "/");
// put campaign status profile
export const putCampaignStatusProfile = (id, data) => put(url.GET_CAMPAIGN_STATUSES + id + "/", data);

// get campaign source
export const getCampaignSources = params => get(url.GET_CAMPAIGN_SOURCES, { params });
// post campaign source
export const postCampaignSource = data => post(url.GET_CAMPAIGN_SOURCES, data);
// delete campaign source
export const deleteCampaignSource = id => del(url.GET_CAMPAIGN_SOURCES + id + "/");
// get campaign source profile
export const getCampaignSourceProfile = id => get(url.GET_CAMPAIGN_SOURCES + id + "/");
// put campaign source profile
export const putCampaignSourceProfile = (id, data) => put(url.GET_CAMPAIGN_SOURCES + id + "/", data);

// get campaign direction types
export const getCampaignDirectionType = params => get(url.GET_CAMPAIGN_DIRECTION_TYPE, { params });
// post campaign direction types
export const postCampaignDirectionType = data => post(url.GET_CAMPAIGN_DIRECTION_TYPE, data);
// delete campaign direction types
export const deleteCampaignDirectionType = id => del(url.GET_CAMPAIGN_DIRECTION_TYPE + id + "/");
// get campaign direction types profile
export const getCampaignDirectionTypeProfile = id => get(url.GET_CAMPAIGN_DIRECTION_TYPE + id + "/");
// put campaign direction types profile
export const putCampaignDirectionTypeProfile = (id, data) => put(url.GET_CAMPAIGN_DIRECTION_TYPE + id + "/", data);

// get campaign device types
export const getCampaignDeviceType = params => get(url.GET_CAMPAIGN_DEVICE_TYPE, { params });
// post campaign device types
export const postCampaignDeviceType = data => post(url.GET_CAMPAIGN_DEVICE_TYPE, data);
// delete campaign device types
export const deleteCampaignDeviceType = id => del(url.GET_CAMPAIGN_DEVICE_TYPE + id + "/");
// get campaign device types profile
export const getCampaignDeviceTypeProfile = id => get(url.GET_CAMPAIGN_DEVICE_TYPE + id + "/");
// put campaign device types profile
export const putCampaignDeviceTypeProfile = (id, data) => put(url.GET_CAMPAIGN_DEVICE_TYPE + id + "/", data);

// get campaign offer types
export const getCampaignOfferTypeParams = params => get(url.GET_CAMPAIGNS_OFFER_TYPE, { params });
// post campaign offer types
export const postCampaignOfferType = data => post(url.GET_CAMPAIGNS_OFFER_TYPE, data);
// delete campaign offer types
export const deleteCampaignOfferType = id => del(url.GET_CAMPAIGNS_OFFER_TYPE + id + "/");
// get campaign offer types profile
export const getCampaignOfferTypeProfile = id => get(url.GET_CAMPAIGNS_OFFER_TYPE + id + "/");
// put campaign offer types profile
export const putCampaignOfferTypeProfile = (id, data) => put(url.GET_CAMPAIGNS_OFFER_TYPE + id + "/", data);

// get campaign media buyer
export const getCampaignMediaBuyerParams = params => get(url.GET_CAMPAIGNS_MEDIA_BUYER, { params });
// post campaign media buyer
export const postCampaignMediaBuyer = data => post(url.GET_CAMPAIGNS_MEDIA_BUYER, data);
// delete campaigns media buyer
export const deleteCampaignMediaBuyer = id => del(url.GET_CAMPAIGNS_MEDIA_BUYER + id + "/");
// get campaigns media buyer profile
export const getCampaignMediaBuyerProfile = id => get(url.GET_CAMPAIGNS_MEDIA_BUYER + id + "/");
// put campaign media buyer profile
export const putCampaignMediaBuyerProfile = (id, data) => put(url.GET_CAMPAIGNS_MEDIA_BUYER + id + "/", data);

// get campaign advertising-accounts
export const getCampaignAdvertisingAccount = params => get(url.GET_CAMPAIGNS_ADVERTISING_ACCOUNT, { params });
// post campaign cabinet
export const postCampaignAdvertisingAccount = data => post(url.GET_CAMPAIGNS_ADVERTISING_ACCOUNT, data);
// delete campaigns cabinet
export const deleteCampaignAdvertisingAccount = id => del(url.GET_CAMPAIGNS_ADVERTISING_ACCOUNT + id + "/");
// get campaigns cabinet profile
export const getCampaignAdvertisingAccountProfile = id => get(url.GET_CAMPAIGNS_ADVERTISING_ACCOUNT + id + "/");
// put campaign cabinet profile
export const putCampaignAdvertisingAccountProfile = (id, data) => put(url.GET_CAMPAIGNS_ADVERTISING_ACCOUNT + id + "/", data);
// get campaign customers data
export const getCampaignAdvertisingAccountCustomerData = params => get(url.GET_CAMPAIGNS_ADVERTISING_ACCOUNT + 'customers_data/');

export const postWarehouseLoadPlatformCabinets = params => post(url.WAREHOUSE_LOAD_PLATFORM_CABINETS, params);


// get campaign cashbacks
export const getCampaignCashbacks = params => get(url.GET_CAMPAIGNS_CASHBACK, { params });
// post campaign cashback
export const postCampaignCashback = data => post(url.GET_CAMPAIGNS_CASHBACK, data);
// delete campaigns cashback
export const deleteCampaignCashback = id => del(url.GET_CAMPAIGNS_CASHBACK + id + "/");
// get campaigns cashback profile
export const getCampaignCashbackProfile = id => get(url.GET_CAMPAIGNS_CASHBACK + id + "/");
// put campaign cashback profile
export const putCampaignCashbackProfile = (id, data) => put(url.GET_CAMPAIGNS_CASHBACK + id + "/", data);

// get campaign custom names types
export const getCampaignCustomNames = params => get(url.GET_CAMPAIGN_CUSTOM_NAMES, { params });
// post campaign custom names types
export const postCampaignCustomNames = data => post(url.GET_CAMPAIGN_CUSTOM_NAMES, data);
// delete campaign custom names types
export const deleteCampaignCustomNames = id => del(url.GET_CAMPAIGN_CUSTOM_NAMES + id + "/");
// get campaign custom names types profile
export const getCampaignCustomNamesProfile = id => get(url.GET_CAMPAIGN_CUSTOM_NAMES + id + "/");
// put campaign custom names types profile
export const putCampaignCustomNamesProfile = (id, data) => put(url.GET_CAMPAIGN_CUSTOM_NAMES + id + "/", data);

// get campaign media buyer
export const getCampaignMediaBuyer = () => get(url.GET_CAMPAIGNS_MEDIA_BUYER);
// get campaign offer type
export const getCampaignOfferType = () => get(url.GET_CAMPAIGNS_OFFER_TYPE);

// get reports
export const getQualityStats = params => get(url.API_REPORT_QUALITY + 'stats/', { params });
export const getQualityFilters = params => get(url.API_REPORT_QUALITY + 'filters/', { params });
export const getQualityWidgets = params => get(url.API_REPORT_QUALITY + 'widgets/', { params });
export const getTopManagementMediaBuyerProfit = params => get(url.API_REPORT_TOPMANAGEMENT + 'mediabuyer-profit/', { params });
export const getTopManagementOfferProfit = params => get(url.API_REPORT_TOPMANAGEMENT + 'offer-profit/', { params });
export const getTopManagementProfit = params => get(url.API_REPORT_TOPMANAGEMENT + 'profit/', { params });
export const getTopManagementAppProfit = params => get(url.API_REPORT_TOPMANAGEMENT + 'app-profit/', { params });
export const getTopManagementMediaBuyerStats= params => get(url.API_REPORT_TOPMANAGEMENT + 'mediabuyer-stats/', { params });
export const getTopManagementMediaBuyerSpend = params => get(url.API_REPORT_TOPMANAGEMENT + 'mediabuyer-spend/', { params });
export const getTopManagementClientSpend = params => get(url.API_REPORT_TOPMANAGEMENT + 'client-spend/', { params });
export const getCampaignsCountBy = params => get(url.API_REPORT + 'campaigns-count-by/', { params });
export const getPaymentCostInspectionReportList = params => get(url.API_REPORT_PAYMENT_COST, { params });
export const getPaymentCostInspectionReportFilters = () => get(url.API_REPORT_PAYMENT_COST + 'filter_data/');
export const postReportRequestDataUpdate = (params) => post(url.API_REQUEST_DATA_UPDATE + `?date_from=${params.date_from}&date_to=${params.date_to}&app_id=${params.app_id}`);
export const getReportQualityEventsStats = (params) => get(url.API_REPORT_EVENTS_STATS, { params })

// rent reports
export const getReportRentStats = (params) => get(url.API_REPORT + `/quality_rent/stats/`, { params });
export const getReportRentWidgets = (params) => get(url.API_REPORT + `/quality_rent/widgets/`, { params });

// Applications
export const getDataForApp = (link) => get(url.GET_APP_DATA + `?link=${link}`);
export const getAppsParams = params => get(url.GET_APPLICATIONS, { params });
export const getApps = () => get(url.GET_APPLICATIONS);
export const getClientApps = (id, params) => get(url.GET_APPLICATIONS + "?client=" + id, { params });
export const getApp = id => get(url.GET_APPLICATIONS + id + "/");

export const addApp = (data) => post(url.GET_APPLICATIONS, data);
export const delApp = (id) => del(url.GET_APPLICATIONS + id + '/');
export const patchApp = (id, params) => patch(url.GET_APPLICATIONS + id + '/', params);
// Login Method
export const postLogin = data => post(url.POST_LOGIN, data);

// Token refresh Method
export const postTokenRefresh = data => post(url.POST_TOKEN_REFRESH, data);

// Get permissions Method
export const getPermissions = data => get(url.GET_PERMISSIONS, data);

// Meta
export const getCountries = () => get(url.GET_COUNTRIES);
export const getTrackingPlatforms = () => get(url.META_TRACKING_PLATFORMS);
export const getMetaAdPlatforms = () => get(url.META_AD_PLATFORMS);

// Mapper
export const postMapperFiles = (formData) => post(url.API_MAPPER + 'files/', formData, {
  headers: {
    "accept": "application/json",
    // "Access-Control-Allow-Origin": "*",
    // "Content-Type": "multipart/form-data;",
    "Content-Type": "multipart/form-data; boundary=----WebKitFormBoundary3vMCbUC48UL7bRn0"
    // "Content-Length": 58
  }
});
export const getMapperModels = () => get(url.API_MAPPER + 'models/');
export const getMapperModelId = (id) => get(url.API_MAPPER + `models/${id}/`);
export const postBasicMapping = (id, data) => post(url.API_MAPPER + `models/${id}/basic_mapping/`, data);
export const postMapperValidation = (id, params) => post(url.API_MAPPER + `models/${id}/validate/`, params)

export const getMapperTemplatesApi = (params) => get(url.API_MAPPER + 'templates/', { params });
export const getMapperTemplate = (id) => get(url.API_MAPPER + `templates/${id}/`);
export const postMapperTemplate = (params) => post(url.API_MAPPER + `templates/`, params);
export const patchMapperTemplate = (id, data) => patch(url.API_MAPPER + `templates/${id}`, data);
export const deleteMapperTemplate = (id) => del(url.API_MAPPER + `templates/${id}/`);
export const getMapperFilesApi = (params) => get(url.API_MAPPER + 'files/', { params });
export const deleteMapperFileApi = (id) => del(url.API_MAPPER + `files/${id}/`);

// Salary Bonuses
export const getSalaryBonuses = (params) => get(url.API_SALARY_BONUSES, { params });
export const postSalaryBonuses = (params) => post(url.API_SALARY_BONUSES, params );
export const deleteSalaryBonuses = (id) => del(url.API_SALARY_BONUSES + `${id}/`);
export const patchSalaryBonuses = (id, params) => patch(url.API_SALARY_BONUSES + `${id}/`, params );

// Bank details
export const getBankDetails = (params) => get(url.API_BANK_DETAILS, { params });
export const getBankDetailsByUser = (params) => get(url.API_BANK_DETAILS, { params });
export const postBankDetails = (params) => post(url.API_BANK_DETAILS, params)
export const patchBankDetails = (id, params) => patch(url.API_BANK_DETAILS + id + '/', params);
export const deleteBankDetails = (id) => del(url.API_BANK_DETAILS + id + '/');

// Bank correspondents
export const getBankCorrespondents = (params) => get(url.API_BANK_CORRESPONDENTS, { params });
export const postBankCorrespondents = (params) => post(url.API_BANK_CORRESPONDENTS, params);
export const patchBankCorrespondent = (id, params) => patch(url.API_BANK_CORRESPONDENTS + id + '/', params);
export const deleteBankCorrespondent = (id) => del(url.API_BANK_CORRESPONDENTS + id + '/');

// Bank uploading
export const getBankUploading = (params) => get(url.API_BANK_UPLOADING, { params });
export const patchBankUploading = (id, params) => patch(url.API_BANK_UPLOADING + `${id}/`, params);
export const deleteBankUploading = (id) => del(url.API_BANK_UPLOADING + `${id}/`);
export const getBankUploadingById = (id) => get(url.API_BANK_UPLOADING + `${id}/`);

// Plan Payout Conditions PLAN_PAYOUT
export const getPayoutConditions = (params) => get(url.PLAN_PAYOUT, { params });
export const postPayoutCondition = (params) => post(url.PLAN_PAYOUT, params);
export const patchPayoutCondition = (params) => patch(url.PLAN_PAYOUT, params);
export const deletePayoutCondition = (params) => del(url.PLAN_PAYOUT + `?ids=${params.ids}`);

// Plan Payout Conditions Media Buyer PLAN_PAYOUT
export const getPayoutConditionsMediaBuyer = (params) => get(url.MEDIA_BUYER_PLAN_PAYOUT, { params });
export const postPayoutConditionMediaBuyer = (params) => post(url.MEDIA_BUYER_PLAN_PAYOUT, params);
export const patchPayoutConditionMediaBuyer = (params) => patch(url.MEDIA_BUYER_PLAN_PAYOUT, params);
export const deletePayoutConditionMediaBuyer = (params) => del(url.MEDIA_BUYER_PLAN_PAYOUT + `?ids=${params.ids}`);
export const getManagersPlansWithStats = (params) => get(url.PLAN_MANAGERS_WITH_STATS, { params });
export const getOffersPlansWithStats = (params) => get(url.PLAN_OFFERS_WITH_STATS, { params });

// Transactions
export const getTransactionReconciliation = (params) => get(url.API_TRANSACTIONS + 'reconciliation/', { params });
export const getTransactionChart = (params) => get(url.API_TRANSACTIONS + '/reconciliation_chart/', { params });

// Warehouse 
export const getWarehouseCheckCampaignNames = (params) => get(url.API_WAREHOUSE_CHECK_CAMPAIGN_NAMES, { params });
export const getWarehouseCabinetLimits = (params) => get(url.API_WAREHOUSE_CABINET_LIMITS, { params });
export const getWarehouseCabinetLimitsTotal = (params) => get(url.API_WAREHOUSE_CABINET_LIMITS + 'total/', { params });
